import { render, staticRenderFns } from "./listen-whisper.vue?vue&type=template&id=0bb4775c&scoped=true"
import script from "./listen-whisper.vue?vue&type=script&lang=js"
export * from "./listen-whisper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb4775c",
  null
  
)

export default component.exports